import { CSSResultArray } from 'lit';
import host from '@maersk-global/mds-components-utils/host/host.styles.js';
import style from './mc-notification.scss';
import tokens from '@maersk-global/mds-design-tokens/implementation/core/notification/js/design-tokens-px.css.js';
export const styles: CSSResultArray = [host, tokens, style];
